import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CardPaymentEffects} from '../cart/store/effects/card-payment.effect';
import {CyberSourceEffects} from './services/store/effects/cyber-source.effects';
import {StripeEffects} from './services/store/effects/stripe.effects';
import {PAYMENT_AUTHORIZATION_FEATURE} from './services/store/payment-state';
import * as fromCyberSource from './services/store/reducers/cyber-source.reducer';
import * as fromDelego from './services/store/reducers/delego.reducer';
import * as fromStripe from './services/store/reducers/stripe.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(PAYMENT_AUTHORIZATION_FEATURE, {
      delego: fromDelego.delegoReducer,
      stripe: fromStripe.stripeReducer,
      cyberSource: fromCyberSource.cyberSourceReducer,
    }),
    EffectsModule.forFeature([CardPaymentEffects, StripeEffects, CyberSourceEffects]),
  ],
})
export class PaymentStoreModule {}
